/**
 * File types of temporary files.
 */
export enum DermloopTempFileType {
  Pdf = 'Pdf',
}

/**
 * Source of temporary files.
 */
export enum DermloopTempFileSource {
  Xdis91 = 'Xdis91',
}

/**
 * Status of temporary files.
 */
export enum DermloopTempFileStatus {
  AwaitingUpload = 'AwaitingUpload',
  Uploaded = 'Uploaded',
}
